import { reactive } from 'vue'

export const ALL_SPORTS = 'ALL'
const KEY = 'calendarSport'

function read(): string {
    try {
        return localStorage.getItem(KEY) || 'CRICKET'
    } catch (e) {
        return 'CRICKET'
    }
}

export const calendarSport = reactive({ value: read() })

export function setCalendarSport(sport: string) {
    calendarSport.value = sport
    try {
        localStorage.setItem(KEY, sport)
    } catch (e) {
        // preference is optional
    }
}

export function sportLabel(sport: string): string {
    if (sport === ALL_SPORTS) return 'All sports'
    return sport.charAt(0) + sport.slice(1).toLowerCase().replace(/_/g, ' ')
}
